import { render, staticRenderFns } from "./TonalCommentHeader.vue?vue&type=template&id=05dc019b&"
import script from "./TonalCommentHeader.vue?vue&type=script&lang=js&"
export * from "./TonalCommentHeader.vue?vue&type=script&lang=js&"
import style0 from "./TonalCommentHeader.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports